exports.isEmpty = (param, error = null) =>{
    if(param !== undefined && param !== null && param !== '' && !error){
        return false;
    }
    return true;
}